import { OrderStatusEnum } from '@modules/orders-module/enums/order-status.enum'

export const OpenOrderStatuses: OrderStatusEnum[] = [
	OrderStatusEnum.NEW,
	OrderStatusEnum.ACCEPTED,
	OrderStatusEnum.PENDING_NEW,
	OrderStatusEnum.HELD,
	OrderStatusEnum.PENDING_CANCEL,
	OrderStatusEnum.PARTIALLY_FILLED,
]
